import { render, staticRenderFns } from "./ConvoyWagon.vue?vue&type=template&id=30a55f21&scoped=true"
import script from "./ConvoyWagon.vue?vue&type=script&lang=js"
export * from "./ConvoyWagon.vue?vue&type=script&lang=js"
import style0 from "./ConvoyWagon.vue?vue&type=style&index=0&id=30a55f21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a55f21",
  null
  
)

export default component.exports